"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gasForesight = void 0;
const gasForesight = exports.gasForesight = {
  GAS_FORESIGHT: {
    en: {
      title: 'ICIS Gas Foresight',
      subtitle: 'Optimise purchasing with the leader in gas pricing',
      description: 'Seize opportunities, with granular gas and LNG market intelligence.',
      list: ['‘Fair value’ European gas forecast driven by over 400 million data points', 'Daily pricing, supply and demand forecasts, commentary and analysis for all major European gas hubs up to 36 months ahead', 'Weekly market outlook for European, US and Asian gas fundamentals including LNG']
    },
    zh: {
      title: 'ICIS天然气预测与分析',
      subtitle: '领先的天然气价格资讯优化您的采购',
      description: '详尽的天然气和LNG市场资讯，助您把握良机。',
      list: ['基于4亿多个数据点，得出欧洲天然气预测的“公允价值”', '覆盖欧洲所有主要天然气枢纽的日度价格、供需预测、评述与分析，时间跨度达未来36个月', '包括LNG在内的欧美亚天然气市场基本面的周度展望']
    }
  }
};